import { formatValue } from 'react-currency-input-field';
import React, { useMemo } from 'react';
import styled from 'styled-components';
import AddCircleIcon from '@material-ui/icons/AddCircle';
import { useHistory } from 'react-router';
import i18n from '../../i18n/i18n';
import NewLogo from '../../images/logo_elecctro_colored.png';
import CardBackground1 from '../../images/card_background_1.jpg';
import CardBackgroundHelexia from '../../images/cardBackgroundHelexia.svg';
import MifareLogo from '../../images/mifare_logo.png';
import { ReactComponent as MBWayLogo } from '../../images/MBWAY_PagAutorizados.svg';
import Visa from '../../images/visa.svg';
import Mastercard from '../../images/mastercard.svg';
import Diners from '../../images/diners.svg';
import Discover from '../../images/discover.svg';
import Unionpay from '../../images/unionpay.svg';
import { useTheme } from '../../contexts/ThemeContext';
import { useUser } from '../../contexts/UserContext';

const StyledSpan = styled.span`
  display: flex;
  justify-content: center;
  align-items: center;
  max-height: 30px;
`;

const CARD_STYLE = styled.div`
  position: relative;
  width: 100%;
  min-height: 160px;
  text-align: center;
  background: url(${(props) => props.bgImage || CardBackground1}) no-repeat 0 0 white;
  background-size: cover;
  font-family: sans-serif;
  font-size: 12px;
  text-transform: uppercase;
  border-radius: 10px;
  box-sizing: border-box;
  box-shadow: -5px 5px 20px 0 rgba(0, 0, 0, 0.55);
`;

const Chip = styled.div`
  width: 28%;
  height: 3.3vh;
  background: url(${(props) => (props.gatewayName === 'TOKEN' ? MifareLogo : MBWayLogo)}) no-repeat 0 0;
  background-size: contain;
  border-radius: 8px;
  position: relative;
  margin-left: 20px;
`;

const StyledMbWayLogo = styled(MBWayLogo)`
  width: 100%;
  height: 14vh;
`;

const Logo = styled.div`
  width: 28%;
  height: 2.5vh;
  padding-right: 20px;
  background: url(${NewLogo}) no-repeat 0 0;
  background-size: contain;
`;

const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  min-height: 50%;
`;

const PrivateCard = ({
  paymentMethod, walletAmount, color, onClick
}) => {
  const currentLanguage = useMemo(
    () => `${i18n.language[0]}${i18n.language[1]}-${i18n.language[2]}${i18n.language[3]}`,
    [i18n.language],
  );

  const history = useHistory();
  const { themeName } = useTheme();
  const { user } = useUser();
  const isHelexia = themeName === 'helexia';
  const isGalp = themeName === 'galp';

  switch (paymentMethod?.gatewayName) {
    case 'TOKEN':
      if (isGalp) {
        const cardNumber = paymentMethod?.wallet?.number || '';
        const last4 = cardNumber.slice(-4);
        const maskedLen = Math.max(cardNumber.length - 4, 0);
        const maskGroups = [];
        for (let i = 0; i < maskedLen; i += 4) {
          maskGroups.push('••••'.slice(0, Math.min(4, maskedLen - i)));
        }
        const holderName = user?.user?.name
          || (user?.user?.email ? user.user.email.split('@')[0].replace(/[._-]/g, ' ') : '');

        const galpLabel = {
          color: 'rgba(255, 255, 255, 0.85)',
          fontFamily: 'Poppins, sans-serif',
          fontSize: '8px',
          fontWeight: 400,
          textTransform: 'none',
          letterSpacing: 0,
          textAlign: 'left',
        };
        const galpValue = {
          color: 'white',
          fontFamily: 'Poppins, sans-serif',
          fontSize: '12px',
          fontWeight: 700,
          letterSpacing: 0,
          whiteSpace: 'nowrap',
          textAlign: 'left',
        };

        return (
          <CARD_STYLE
            key={paymentMethod.id}
            onClick={onClick}
            style={{
              background: 'linear-gradient(135deg, #EEBBA3 0%, #EF9A72 45%, #FB6E34 100%)',
              borderRadius: '12px',
              border: '2px solid rgba(57, 56, 58, 0.35)',
              boxShadow: '0 10px 20px rgba(0, 0, 0, 0.15)',
              textTransform: 'none',
              overflow: 'hidden',
            }}
          >
            <div style={{
              position: 'absolute',
              inset: 0,
              background: 'radial-gradient(circle at 14% 10%, rgba(255,255,255,0.6), rgba(255,255,255,0) 55%)',
              pointerEvents: 'none',
            }}
            />
            <div style={{
              position: 'relative',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
              minHeight: '150px',
              padding: '16px',
              boxSizing: 'border-box',
            }}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span style={{
                  color: 'white',
                  fontFamily: 'Poppins, sans-serif',
                  fontSize: '12px',
                  fontWeight: 600,
                  textTransform: 'none',
                }}
                >
                  ADRBank
                </span>
                <span style={{
                  width: '18px',
                  height: '18px',
                  borderRadius: '50%',
                  background: 'rgba(255, 255, 255, 0.9)',
                  display: 'inline-block',
                }}
                />
              </div>

              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '8px',
                flexWrap: 'nowrap',
              }}
              >
                {maskGroups.map((group, i) => (
                  <span
                    // eslint-disable-next-line react/no-array-index-key
                    key={i}
                    style={{ color: 'white', fontSize: '21px', letterSpacing: '2px' }}
                  >
                    {group}
                  </span>
                ))}
                <span style={{
                  color: 'white',
                  fontFamily: 'Poppins, sans-serif',
                  fontSize: '21px',
                  fontWeight: 700,
                  letterSpacing: '2px',
                  textTransform: 'uppercase',
                }}
                >
                  {last4}
                </span>
              </div>

              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end' }}>
                <div style={{ display: 'flex', gap: '28px', alignItems: 'flex-start' }}>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                    <span style={galpLabel}>{i18n.t('card_holder_name')}</span>
                    <span style={{ ...galpValue, textTransform: 'uppercase' }}>{holderName}</span>
                  </div>
                  <div style={{ display: 'flex', flexDirection: 'column', gap: '2px' }}>
                    <span style={galpLabel}>{i18n.t('expiry_date')}</span>
                    <span style={{ ...galpValue, textTransform: 'none' }}>
                      {paymentMethod?.wallet?.expirationDate}
                    </span>
                  </div>
                </div>
                <div style={{ display: 'flex', alignItems: 'center', marginLeft: '4px' }}>
                  <span style={{
                    width: '20px',
                    height: '20px',
                    borderRadius: '50%',
                    background: '#EB001B',
                    display: 'inline-block',
                  }}
                  />
                  <span style={{
                    width: '20px',
                    height: '20px',
                    borderRadius: '50%',
                    background: 'rgba(247, 158, 27, 0.9)',
                    display: 'inline-block',
                    marginLeft: '-9px',
                  }}
                  />
                </div>
              </div>
            </div>
          </CARD_STYLE>
        );
      }

      if (isHelexia) {
        return (
          <CARD_STYLE
            key={paymentMethod.id}
            onClick={onClick}
            bgImage={CardBackgroundHelexia}
            style={{ boxShadow: '20px 24px 20px rgba(0, 0, 0, 0.25)', borderRadius: '3px' }}
          >
            <div style={{
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
              padding: '14px 16px 14px 16px',
              minHeight: '160px',
              boxSizing: 'border-box',
            }}
            >
              {/* Top row: expiry date */}
              <span style={{
                color: 'white',
                fontSize: '9.36px',
                fontFamily: 'Geologica, sans-serif',
                fontWeight: 500,
                textTransform: 'none',
                letterSpacing: 0,
              }}
              >
                {paymentMethod?.wallet?.expirationDate}
              </span>

              {/* Bottom section: masked number + label */}
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: '2px', marginBottom: '10px' }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                  {paymentMethod?.wallet?.number && (() => {
                    const masked = paymentMethod.wallet.number.slice(0, -4);
                    const groups = [];
                    for (let i = 0; i < masked.length; i += 4) groups.push(masked.slice(i, i + 4).replace(/./g, '•'));
                    return groups.map((group, i) => (
                      <span key={i} style={{ color: 'white', fontSize: '15px', letterSpacing: '3px' }}>{group}</span>
                    ));
                  })()}
                  <span style={{
                    color: 'white',
                    fontSize: '10.86px',
                    fontFamily: 'Geologica, sans-serif',
                    fontWeight: 600,
                    letterSpacing: 0,
                  }}
                  >
                    {paymentMethod?.wallet?.number?.slice(-4)}
                  </span>
                </div>
                <span style={{
                  color: 'white',
                  fontSize: '10px',
                  fontFamily: 'Geologica, sans-serif',
                  fontWeight: 500,
                  textTransform: 'none',
                }}
                >
                  {i18n.t('card_number')}
                </span>
              </div>
            </div>
          </CARD_STYLE>
        );
      }

      return (
        <CARD_STYLE key={paymentMethod.id} onClick={onClick}>
          <div style={{
            paddingTop: '8%',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            alignContent: 'center',
            flexDirection: 'row',
          }}
          >
            <Chip gatewayName="TOKEN" />
            <Logo />
          </div>
          <>
            <div style={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              alignContent: 'center',
              flexDirection: 'row',
            }}
            >
              <div style={{
                color: 'rgb(28,28,28)',
                display: 'flex',
                marginLeft: 20,
                flexDirection: 'column',
                width: '100%',
                justifyContent: 'center',
                alignItems: 'flex-start',
                position: 'relative',
                textShadow: '-0.5px -0.5px 0px rgba(255,255,255,0.3), 0.5px 0.5px 0px rgba(0,0,0,0.8)',
                letterSpacing: 2,
              }}
              >
                <h2 style={{
                  textAlign: 'left',
                  fontSize: '1.5em',
                  textShadow: '-1px -1px 0px rgba(255,255,255,0.3), 0.5px 0.5px 0px rgba(0,0,0,0.8)',
                  letterSpacing: 2,
                  color,
                }}
                >
                  {paymentMethod?.wallet?.number?.slice(-4)}
                </h2>
                <span style={{
                  textAlign: 'left',
                  fontSize: '1em',
                  textShadow: '-1px -1px 0px rgba(255,255,255,0.3), 0.5px 0.5px 0px rgba(0,0,0,0.8)',
                  letterSpacing: 2,
                }}
                >
                  {paymentMethod?.wallet?.tokenSchema}
                </span>
                <StyledSpan style={{ fontSize: '1em' }}>
                  <span>
                    {paymentMethod?.wallet?.currencyCode === 'XXX'
                      ? `${walletAmount} ${i18n.t('services')}`
                      : formatValue({
                        value: walletAmount,
                        groupSeparator: ',',
                        decimalSeparator: '.',
                        decimalScale: 2,
                        intlConfig: {
                          locale: currentLanguage,
                          currency: paymentMethod?.wallet?.currencyCode,
                        },
                      })}
                  </span>
                </StyledSpan>
              </div>
              <div
                style={{
                  color,
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'end',
                  height: '80px',
                  marginRight: '10px',
                }}
              >
                {paymentMethod?.wallet?.isWalletRevaluable
                  && (
                    <AddCircleIcon
                      fontSize="large"
                      onClick={() => {
                        if (paymentMethod?.wallet?.isWalletRevaluable) {
                          history.push('/revalue-amount-selection', { wallet: paymentMethod?.wallet, color });
                        }
                      }}
                    />
                  )}
              </div>
            </div>
          </>
        </CARD_STYLE>
      );
    case 'SPG':
      if (isGalp) {
        return (
          <CARD_STYLE
            key={paymentMethod.id}
            onClick={onClick}
            style={{
              background: '#fbfbfb',
              borderRadius: '10px',
              boxShadow: '0 8px 20px rgba(0, 0, 0, 0.12)',
              textTransform: 'none',
              minHeight: '160px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              padding: '24px',
              boxSizing: 'border-box',
            }}
          >
            <StyledMbWayLogo style={{ width: '55%', height: 'auto' }} />
          </CARD_STYLE>
        );
      }

      return (
        <CARD_STYLE key={paymentMethod.id} onClick={onClick}>
          <div style={{
            paddingTop: '8%',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            alignContent: 'center',
            flexDirection: 'row',
          }}
          >
            <StyledMbWayLogo />
          </div>
        </CARD_STYLE>
      );

    case 'SPGCARD':
      return (
        <CARD_STYLE key={paymentMethod.id} onClick={onClick}>
          <div style={{ height: '100%' }} className="cartoes-container">
            <Row>
              <img src={Visa} alt="Visa" style={{ width: '30%', height: '7vh' }} />
              <img src={Mastercard} alt="Mastercard" style={{ width: '30%', height: '4vh' }} />
              <img src={Diners} alt="Diners Club" style={{ width: '30%', height: '4vh' }} />
            </Row>
            <Row>
              <img src={Discover} alt="Discover" style={{ width: '30%', height: '10vh' }} />
              <img src={Unionpay} alt="Union Pay" style={{ width: '30%', height: '4vh' }} />
            </Row>
          </div>
        </CARD_STYLE>
      );
    default:
      return null;
  }
};

export default PrivateCard;
